<script setup>

import { ElButton, ElSwitch  } from 'element-plus';
import { onMounted, ref } from 'vue';
import { CaretBottom, CaretTop } from '@element-plus/icons-vue';
import { useProductStore } from '../../stores/fpe';
import { storeToRefs } from 'pinia';
import axios from 'axios';

const props = defineProps(['attribute', 'node','type']);
const productType = ref(props.type);
const store = useProductStore();

const tags = ref([]);

const attribute_string = ref(props.attribute.options.join('|'));

const openPanel = ref(false);

const searchAttributes = (query) => {
    const { ajax_url, security } = fpe;
    const that = this;
    axios.post(`${ajax_url}?action=fpe_search_attribute_terms&fpe_nonce=${security}`, {
        attribute: props.attribute.name,
        query: query
    }).then( function (response) {
        tags.value = response.data;
    }).catch(function (error){
        console.error(error);
    })
}

const selectAll = () => {
    
    const { ajax_url, security } = fpe;
    const that = this;

    axios.post(`${ajax_url}?action=fpe_get_attribute_terms&fpe_nonce=${security}`, {
        attribute: props.attribute.name,
    }).then( function (response) {
        props.attribute.options = response.data;
    }).catch(function (error){
        console.error(error);
    })
}


onMounted(() => {
    if(props.attribute.is_taxonomy && props.attribute.options.length) {
        const { ajax_url, security } = fpe;
        const that = this;
        axios.post(`${ajax_url}?action=fpe_get_attribute_terms&fpe_nonce=${security}`, {
            attribute: props.attribute.name,
            term_ids: props.attribute.options
        }).then( function (response) {
            props.attribute.options = response.data;
        }).catch(function (error){
            console.error(error);
        })
    }
});

</script>

<template>

    <div class="fpe-attribute-header" @click="openPanel = !openPanel" :data-attribute="attribute.name">
        <span class="fpe-attribute-name">{{ attribute.label || attribute.name }}</span>
        <ElIcon class="fpe-attribute-icon">
            <CaretBottom v-if="!openPanel" />
            <CaretTop v-if="openPanel" />
        </ElIcon>
    </div>

    <div class="fpe-attribute-form" v-if="openPanel">

        <div class="fpe-field-wrapper fpe-field-inline">
            <label>Attribute Name<span v-if="props.attribute.is_taxonomy">: {{ props.attribute.label }}</span></label>
            <ElInput v-if="!props.attribute.is_taxonomy" v-model="props.attribute.name" />
        </div>
 
        <div class="fpe-field-wrapper fpe-field-inline">
            <label>Visible on Product Page</label>
            <ElSwitch v-model="props.attribute.visible" />
        </div>
        
        <div class="fpe-field-wrapper fpe-field-inline" v-if="productType == 'variable'">
            <label>Used For Variation</label>
            <ElSwitch v-model="props.attribute.variation" />
        </div>
        
        <div class="fpe-field-wrapper">
            <label>Value(s)</label>
            <ElInput 
                type="textarea" 
                v-if="!props.attribute.is_taxonomy" 
                v-model="attribute_string"
                @input="props.attribute.options = attribute_string.split('|');" 
            />

            <ElSelect
                v-model="props.attribute.options"
                v-if="props.attribute.is_taxonomy"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="searchAttributes"
            >
                <el-option 
                    v-for="(tag, id) in tags"
                    :label="tag"
                    :value=id
                />
            </ElSelect>

            <div v-if="props.attribute.is_taxonomy" class="fpe-attribute-actions">
                <ElButton type="text" @click="selectAll">Select All</ElButton>

                <ElButton type="text" @click="props.attribute.options = []">Select None</ElButton>
            </div>
        </div>
        
        <ElButton class="fpe-remove-attribute" type="danger" :icon="Delete" @click="$emit('ondelete', props.attribute.name)">Remove</ElButton>
    </div>
    


</template>